import React from "react";
import "../Styles/Benefitscards.css";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";

// Dummy membership data — later replace with API data.
// The layout below is written so ANY number of features per plan
// (even mismatched counts across plans) will still render with
// equal card height and width automatically.
const membershipPlans = [
  {
    id: 1,
    title: "Employee",
    originalPrice: "₹1200",
    currentPrice: "Free Now",
    features: [
      "Chapter Events",
      "eNewsletter",
      "Webinar",
      "Podcasts",
      "NHRC Journal Digest",
      "HR Research Reports",
      "10% Discounts on NHRC Events",
      "NHRC eJournal",
    ],
  },
  {
    id: 2,
    title: "Representative (TPO)",
    originalPrice: "₹1200",
    currentPrice: "Free Now",
    features: [
      "Chapter Events",
      "eNewsletter",
      "Webinar",
      "Podcasts",
      "NHRC Journal Digest",
      "HR Research Reports",
      "10% Discounts on NHRC Events",
      "NHRC eJournal",
    ],
  },
  {
    id: 3,
    title: "Student",
    originalPrice: "₹1200",
    currentPrice: "Free Now",
    features: [
      "Chapter Events",
      "eNewsletter",
      "Webinar",
      "Podcasts",
      "NHRC Journal Digest",
      "HR Research Reports",
      "10% Discounts on NHRC Events",
      "NHRC eJournal",
    ],
  },
];

const Benefitscards = () => {
  const handleGetMembership = (plan) => {
    console.log("Selected Membership:", plan);
    alert(`You selected the ${plan.title} membership.`);
  };

  return (
    <section className="mship123-page" id="member-benefits">
      <div className="mship123-heading">
        <h2 className="ben-tittle">MEMBER BENEFITS</h2>
      </div>

      <div className="mship123-grid">
        {membershipPlans.map((plan) => (
          <div className="mship123-card" key={plan.id}>
            <div className="mship123-header">
              <h3 className="mship123-title">{plan.title}</h3>
              <div className="mship123-price-badge">
                <span className="mship123-price-original">
                  {plan.originalPrice}
                </span>
                <span className="mship123-price-free">
                  {plan.currentPrice}
                </span>
              </div>
            </div>

            <ul className="mship123-features">
              {plan.features.map((feature, index) => (
                <li className="mship123-feature-item" key={index}>
                  <IoCheckmarkCircle className="mship123-check-icon" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mship123-button-wrapper">
              <button
                type="button"
                className="mship123-membership-btn"
                onClick={() => handleGetMembership(plan)}
              >
                <span>Get Membership</span>
                <FaArrowRight className="mship123-arrow-icon" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefitscards;